import { URI_MESSAGES_SERVICE } from '@/config/config';
import { io } from 'socket.io-client';

const socket = io(URI_MESSAGES_SERVICE, { autoConnect: false });

export default socket;
